import { Component, Input, OnInit, Inject } from '@angular/core';
import { ConceptContactModel } from './conceptcontact.model';
import { ConceptFamilyModel } from '../conceptfamily/conceptfamily.model';
import { EventEmitter } from '@angular/core';
import { Output } from '@angular/core';
import { AccountsAndTaxesModel } from '../../invoice/preinvoice/accountsandtaxes.model';
import { InvoiceTaxModel } from '../../invoice/preinvoice/invoicetax.model';
import { FormBuilder, UntypedFormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConceptContactComponent } from './conceptcontact.component';
import { ConceptContactService } from './conceptcontact.service';
import { Utils } from "../../../shared/utils";
import { GetUserInfo } from '../../../shared/utils';
import { ConceptModel } from '../concept/concept.model';
import { ConceptFormComponent } from '../concept/concept-form.component';
import { ContactModel } from '../../contact/contact/contact.model';
import { map, Observable } from 'rxjs';
import { Option } from '../../../shared/models/option.model';


@Component({
    selector: 'convfact-conceptcontact-form',
    templateUrl: './conceptcontact-form.component.html',
    styleUrls: ['./conceptcontact.component.css'],
    standalone: false
})

export class ConceptContactFormComponent implements OnInit {
  @Input() conceptContact = new ConceptContactModel;
  @Input() concepts: Array<ConceptModel>;
  @Input() contacts: Array<ContactModel>;
  @Input() errors: object;
  @Output() onSave = new EventEmitter<any>();

  contactCtrl: UntypedFormControl;
  filteredContacts: Observable<ContactModel[]>;
 
  uid: string = this.data.uid;
  submitted = false;
  ready = false;

  public get contactsOptions(): Option[] {
    return (this.contacts || []).map(contact => ({ label: contact.companyName, value: contact.uid }));
  }

  public get conceptsOptions(): Option[] {
    return (this.concepts || []).map(concept => ({ label: concept.name, value: concept.uid }));
  }
 
  constructor(
    public dialogRef: MatDialogRef<ConceptContactComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private conceptContactService: ConceptContactService
  ) { }

  closeDialog() {
    this.dialogRef.close();
  }

  ngOnInit() { 
    this.contactCtrl = new UntypedFormControl();
    this.filteredContacts = this.contactCtrl.valueChanges
      .pipe(map(contact => contact && typeof contact === 'object' ? contact.companyName : contact))
      .pipe(map(name => this.filterContacts(name)));

    if (this.uid !== null) {
      this.conceptContactService.loadData(this.uid).then(response => {
        this.conceptContact = response;
        this.ready = true;
      });
    } else {
      this.ready = true;
    }
  }

  onSubmit() {
    this.submitted = true;
    this.save(this.conceptContact);
  } 
  
  filterContacts(val) {
    const self = this;
    for (const contact of this.contacts) {
      if (contact.companyName === val) {
        self.conceptContact.contactUid = contact.uid;
      }
    }

    return val ? this.contacts.filter(s => s.companyName.toLowerCase().includes(val.toLowerCase()))
      : this.contacts;
  }

  save(concept) {
    this.closeDialog();
    this.onSave.emit(concept);
  }
 
  public trackByIndex(i: number) { return i; }

}
